import { Link } from 'react-router-dom';
import Icon from './Icon';
import { PRODUCTS } from '../constants/content';
import { SUPPORT_PHONE_LABEL, SUPPORT_PHONE_TEL } from '../constants/site';
import { openZohoChat } from '../utils/openZohoChat';

export default function Products() {
  return (
    <section className="section" id="shop">
      <div className="shell">
        <header className="section__head">
          <p className="kicker">Software editions</p>
          <h2>Pick your edition — we take care of the setup</h2>
          <p className="section__lede">
            Genuine publisher licences with official downloads and product keys. Call, order or
            chat — we email the invoice and guide you through installation.
          </p>
        </header>

        <div className="call-strip">
          <span className="call-strip__icon">
            <Icon name="phone" size={22} />
          </span>
          <div className="call-strip__copy">
            <small>Order or ask about any edition</small>
            <a href={SUPPORT_PHONE_TEL}>{SUPPORT_PHONE_LABEL}</a>
          </div>
          <a href={SUPPORT_PHONE_TEL} className="btn btn--green">
            <Icon name="phone" size={18} />
            Call now
          </a>
        </div>

        <div className="grid grid--3 products">
          {PRODUCTS.map((product) => (
            <article className="product product--lift" key={product.id}>
              <div className="product__media">
                <img
                  src={product.image}
                  alt={`${product.edition} ${product.year} software box`}
                  width="450"
                  height="600"
                  loading="lazy"
                  decoding="async"
                />
                {product.badge ? <span className="product__badge">{product.badge}</span> : null}
              </div>
              <p className="product__edition">
                {product.edition} · {product.year}
              </p>
              <h3 className="product__name">{product.name}</h3>
              <p className="product__price">
                <s>{product.was}</s>
                <strong>{product.now}</strong>
              </p>
              <a href={SUPPORT_PHONE_TEL} className="btn btn--dark btn--block">
                <Icon name="phone" size={16} />
                Call to order
              </a>
              <button type="button" className="product__chat" onClick={openZohoChat}>
                or order via chat
              </button>
            </article>
          ))}
        </div>

        <div className="section__actions">
          <a href={SUPPORT_PHONE_TEL} className="btn btn--green">
            <Icon name="phone" size={18} />
            Call {SUPPORT_PHONE_LABEL}
          </a>
          <button type="button" className="btn btn--quiet" onClick={openZohoChat}>
            Ask about editions
          </button>
          <Link to="/contact" className="btn btn--quiet">
            Email sales
          </Link>
        </div>
      </div>
    </section>
  );
}
